<template>
  <vs-row vs-justify="center">
    <vs-col
      style="padding: 0; padding-right: 15px"
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="6"
      vs-sm="12"
      vs-xs="12"
      v-for="(item, index) in mac"
      :key="index"
    >
      <StoreFloor
        :header="nameFloor[index]"
        :mac="mac[index]"
        :TotalWorker="tw"
        :indoorTag="indoorTagData"
      />
    </vs-col>
    <vs-col
      style="padding: 0; padding-right: 15px"
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="6"
      vs-sm="12"
      vs-xs="12"
      v-for="(item, index) in mac"
      :key="index"
    >
      <Temp />
    </vs-col>
  </vs-row>
</template>

<script>
import { Draggable } from "draggable-vue-directive";
import BarChart from "../Overview/Syntec/BarChart.vue";
import moment from "moment";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import StoreFloor from "./components/StoreFloor.vue";
import Temp from "./components/Temp.vue";
export default {
  components: {
    // ManpowerChart,
    BarChart,
    StoreFloor,
    Temp,
  },
  directives: {
    Draggable,
  },

  data: () => ({
    mac: ["AC233FC0BA77"],
    mac_1: ["AC233FC064BF", "AC233FC0BA77"],

    indoorTagData: null,
    tw: 0,
    nameFloor: ["Room 1", "Room 2"],
    nameFloorDemo: ["Office (FL.3)", "Meeting Room (FL.4)"],
    username: "",
    interval:null,
  }),
  created() {
    this.username = this.$session.get("username");
    this.$API.get("indoormanhour").then((result) => {
      console.log("indoormanhour", result);
      result.data.result.forEach((element) => {
        let subDate = element.date.substring(0, 10);
        // console.log("subDate",subDate)

        this.resultIndoorManHour.push({
          date: subDate,
          id: element.id,
          target: element.target,
          username: element.username,
        });
      });

      console.log("this.resultIndoorManHour", this.resultIndoorManHour);
      this.resultIndoorManHour.sort(function (a, b) {
        a = a.date.split("-");
        b = b.date.split("-");
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });
      console.log("this.resultIndoorManHour", this.resultIndoorManHour);
    });

    // this.$API.get("indoortag").then((result) => {
    //   console.log("indoortag", result);
    //   this.indoorTagData = result.data;
    //   result.data.forEach((element) => {
    //     let timeDiff = moment().diff(moment(element.firstdate), "days");
    //     console.log(timeDiff);
    //     // count total worker today
    //     if (timeDiff == 0) {
    //       this.tw++;
    //     }
    //   });
    //   console.log("Tag", result);
    //   console.log(this.tw);
    //   // console.log(this.aw);
    // });
    this.getindoortag()
    
  },
  beforeDestroy(){
    clearTimeout(this.interval)
  },
  methods: {
   async getindoortag() {
      this.tw = 0;
    await  this.$API.get("indoortag").then((result) => {
        console.log("indoortag", result);
        this.indoorTagData = result.data;
        result.data.forEach((element) => {
          let timeDiff = moment().diff(moment(element.firstdate), "days");
          console.log(timeDiff);
          // count total worker today
          if (timeDiff == 0) {
            this.tw++;
          }
        });
        console.log("Tag", result);
        console.log(this.tw);
        // console.log(this.aw);
      });
      this.interval = setTimeout(()=>{
      this.getindoortag()
    }, 1000*20)
    },
  },
};
</script>
<style lang="scss" scoped>
.borderR {
  border-radius: 15px;
}
#app {
  padding: 20px;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.vdatetime.input >>> .form-control {
  display: block;
  width: 100%;
  height: calc(1.45em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.45;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 15px;
}

.layout-store-floor {
  width: 100%;
  display: flex;
}
</style>
